import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import declare from "dojo/_base/declare";
import RecipeLineItemNumber from "./RecipeLineItemNumber";

/**
 * Renderer for RecipeLineItem's QtyDefault
 */
const QtyDefault = declare(RecipeLineItemNumber, {

	/**
	 * @override
	 * Render RecipeLineItem's "QtyDefault" & "AmountAfterH2OLoss" (C8-36029, C8-36606, C8-37600)
	 */
	toValue(ctx: Context, h: Heading) {
		const value = this.getAmount(ctx, (h.m_id == "AmountAfterH2OLoss"));
		return this.formatValue(value, this._getFormat(ctx, h));
	},

});

export = QtyDefault;